
import { format, toDate } from "date-fns";
import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import AcademicFormation from '../../../../models/academic-formation.model';
import { CandidateDetail } from '../../../../models/candidate-detail.model';
import { getLocale } from '../../../../utils/redux/date';
import { toTitleCase } from '../../../../utils/string.utils';
import { SectionBlock } from '../../talent.styled';
import { TitleAbout } from '../about/about.styled';
import { FormationItem, FormationList, FormationTitle, StudyingTag, SubText } from './academic-formation.styled';


interface AcademicFormationExperienceProps {
    candidate: CandidateDetail
}

const AcademicFormationExperience: React.FC<AcademicFormationExperienceProps> = ({ candidate }) => {
    const { t, i18n } = useTranslation('private-home-page');

    const getInterval = useCallback((formation: AcademicFormation) => {
        const FORMAT = "MMMM yyyy";
        const LOCALE_OBJECT = { locale: getLocale(i18n.language) };
    
        const start_date = toDate(Date.parse(formation.start_date || ''));
        const exit_date = formation.end_date ? toDate(Date.parse(formation.end_date)) : null;
    
        return `${toTitleCase(format(start_date, FORMAT, LOCALE_OBJECT))} - ${exit_date && toTitleCase(format(exit_date, FORMAT, LOCALE_OBJECT))}`;
    }, [i18n.language]);

    const getCompleted = useCallback((formation: AcademicFormation): boolean => {
        return toDate(Date.parse(formation.end_date || '')) < new Date();
    }, []);

    return (
        <SectionBlock>
            <TitleAbout>{t('talent.academicEducation')}</TitleAbout>
            <FormationList>
                {candidate?.academic_formation.map(formation => (
                    <FormationItem key={formation.id}>
                        <FormationTitle>
                            {formation.course} 
                            <p>{formation.level_name} </p>
                            {!getCompleted(formation) && (
                                <StudyingTag>{t('talent.formationInProgress')}</StudyingTag>
                            )}
                        </FormationTitle>
                        <SubText><strong>{formation.institution.label}</strong></SubText>
                        <SubText>{getInterval(formation)}</SubText>
                    </FormationItem>
                ))}
            </FormationList>
        </SectionBlock>
    );
}

export default AcademicFormationExperience;
